import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivate } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { HasUnsavedData } from './hasunsaveddata';
import { ConfirmationBoxComponent } from './shared/components/confirmation-box/confirmation-box.component';


@Injectable()
export class HasUnsavedDataGuard implements CanDeactivate<HasUnsavedData> {
    constructor(private dialog: MatDialog, private modalService: NgbModal) {

    }
    canDeactivate(component: HasUnsavedData) {
        if (component.hasUnsavedData && component.hasUnsavedData()) {
            const subject = new Subject<boolean>();
            const modelRef = this.modalService.open(ConfirmationBoxComponent);
            modelRef.componentInstance.title = "Plese confirm";
            modelRef.componentInstance.message = "WARNING: You have some unsaved changes or some process is running. Do you want to continue video creation?";
            modelRef.componentInstance.okButtonText = "No";
            modelRef.componentInstance.cancelButtonText = "Yes";
            modelRef.componentInstance.subject = subject;
            modelRef.result.then((data: any) => {
                subject.complete();
            })
            return subject.asObservable();
        }
        else {
            return true;
        }
    }
}